import React from "react";
import "./CourseDetailSectionStyles.css";
import {
  FaBookOpen,
  FaCalendarAlt,
  FaCheckCircle,
  FaClock,
  FaComments,
  FaCrown,
  FaGift,
  FaGraduationCap,
} from "react-icons/fa";

import type {
  CourseDetail,
  CourseLevelKey,
} from "./CoursesDetails";

type CourseDetailSectionProps = {
  courseLevel: CourseLevelKey;
  course: CourseDetail;
  courseLabel: string;
};

const CourseDetailSection: React.FC<
  CourseDetailSectionProps
> = ({
  courseLevel,
  course,
  courseLabel,
}) => {
  return (
    <section className="course-detail-column">
      <article className="course-detail-card">
        <div className="course-detail-top">
          <div className="course-detail-badge">
            <FaCrown />

            <span>
              Online-Gruppenkurs
            </span>
          </div>

          <div className="course-detail-title-row">
            <div>
              <p>{course.subtitle}</p>

              <h1>{course.title}</h1>
            </div>

            <strong>
              {course.priceGroup}
            </strong>
          </div>

          <p className="course-detail-description">
            {course.description}
          </p>
        </div>

        <div className="course-detail-facts">
          <div className="course-detail-fact">
            <span>
              <FaCalendarAlt />
            </span>

            <div>
              <strong>
                {course.duration}
              </strong>

              <p>Kursdauer</p>
            </div>
          </div>

          <div className="course-detail-fact">
            <span>
              <FaClock />
            </span>

            <div>
              <strong>
                {course.sessions}
              </strong>

              <p>Unterricht</p>
            </div>
          </div>

          <div className="course-detail-fact">
            <span>
              <FaComments />
            </span>

            <div>
              <strong>
                {course.language}
              </strong>

              <p>Erklärsprache</p>
            </div>
          </div>
        </div>

        <div className="course-detail-body">
          <section className="course-detail-section">
            <div className="course-detail-section-heading">
              <FaGraduationCap />

              <div>
                <span>
                  {courseLabel ||
                    courseLevel}
                </span>

                <h2>Kursinhalt</h2>
              </div>
            </div>

            <div className="course-detail-feature-list">
              {course.features.map(
                (feature) => (
                  <div
                    key={feature}
                    className="course-detail-feature"
                  >
                    <FaCheckCircle />

                    <span>
                      {feature}
                    </span>
                  </div>
                ),
              )}
            </div>
          </section>

          <section className="course-detail-section course-detail-books">
            <div className="course-detail-section-heading">
              <FaBookOpen />

              <div>
                <span>
                  Kostenlos inklusive
                </span>

                <h2>10 PDF-Bücher</h2>
              </div>
            </div>

            <p>
              Alle Bücher sind für
              Kursteilnehmer kostenlos
              enthalten. Gesamtwert:{" "}
              <strong>
                {course.booksTotalValue}
              </strong>
            </p>

            <div className="course-detail-book-list">
              {course.books.map((book) => (
                <span key={book.id}>
                  {book.name}

                  <small>Deutsch</small>
                </span>
              ))}
            </div>

            <div className="course-detail-gift">
              <FaGift />

              <div>
                <span>Bonus</span>

                <strong>
                  PDF-Bücher inklusive
                </strong>
              </div>
            </div>
          </section>

          <section className="course-detail-section course-detail-teacher">
            <div className="course-detail-section-heading">
              <FaCrown />

              <div>
                <span>Unterricht</span>

                <h2>
                  Klare Erklärungen
                </h2>
              </div>
            </div>

            <p>
              {course.teacherNote}
            </p>
          </section>
        </div>
      </article>
    </section>
  );
};

export default CourseDetailSection;